export function addHexPrefix(hex: string | undefined) {
  if (hex && !hex?.startsWith('0x')) {
    return '0x' + hex
  }
  return hex
}
